import { useEffect, useState } from 'react';

/**
 * @description: This custom hook handles the height of the OneTrust banner.
 * It sets the height based on the banner's visibility and updates it dynamically.
 * It returns the height of the OneTrust banner. 
 **/
export function useOneTrustBannerHeight() {
  const [oneTrustBannerHeight, setOneTrustBannerHeight] = useState('0rem');

  useEffect(() => {
    let resizeObserver: ResizeObserver | null = null;

    const getOneTrustBannerHeight = (banner: HTMLElement) => {
      setOneTrustBannerHeight(`${banner.offsetHeight / 16}rem`);
    };

    const observeBanner = () => {
      const banner = document.getElementById("onetrust-banner-sdk");
      if (banner && !resizeObserver) {
        resizeObserver = new ResizeObserver(() => getOneTrustBannerHeight(banner));
        resizeObserver.observe(banner);
        getOneTrustBannerHeight(banner);
      }
    };

    observeBanner();

    const observer = new MutationObserver(observeBanner);
    observer.observe(document.body, { childList: true, subtree: true });

    return () => {
      observer.disconnect();
      if (resizeObserver) {
        resizeObserver.disconnect();
      }
    };
  }, []);

  return { oneTrustBannerHeight };
}